export default __webpack_public_path__ + "static/media/payment.dfcc7ed2.png";